import { useTheme } from "@shopify/restyle";
import { useWindowDimensions } from "react-native";

import { Theme } from "../theme/restyle/theme";

type BreakpointValues<T> =
  | {
      [Breakpoint in keyof Theme["breakpoints"]]?: T | null;
    }
  | Array<T | null | undefined>;

export const getBreakpointValue = <T>(
  values: BreakpointValues<T>,
  breakpoints: Theme["breakpoints"],
  width: number
): T | undefined => {
  const sortedBreakpoints = Object.entries(breakpoints).sort(
    ([, firstWidth], [, secondWidth]) => firstWidth - secondWidth
  );
  const responsiveValues = Array.isArray(values)
    ? values
    : sortedBreakpoints.map(
        ([breakpoint]) =>
          Object.entries(values).find(([key]) => key === breakpoint)?.[1]
      );
  let currentBreakpointIndex = -1;

  for (let index = 0; index < sortedBreakpoints.length; index += 1) {
    if (sortedBreakpoints[index][1] <= width) {
      currentBreakpointIndex = index;
    }
  }

  for (let index = currentBreakpointIndex; index >= 0; index -= 1) {
    const value = responsiveValues[index];

    if (value !== null && value !== undefined) {
      return value;
    }
  }

  return undefined;
};

export const useBreakpointValue = <T>(
  values: BreakpointValues<T>
): T | undefined => {
  const theme = useTheme<Theme>();
  const { width } = useWindowDimensions();

  return getBreakpointValue(values, theme.breakpoints, width);
};
